
// Service for realitime functionality.  This is an abstraction to Pusher.
module.factory('RealTime', function(Pusher, $rootScope) {

  // Creates an event handler which re-broadcasts a pusher event on
  // the rootScope.  Events go out with the name:
  //  <eventName>:<modelKey>
  // and are sent with the event data recieved from pusher.
  function emitEvent(eventName) {
    return function(eventData) {
      var name = eventName + ":" + eventData.model_key;
      $rootScope.$emit(name, eventData);
      $rootScope.$emit("updateBadge", [eventData.model_key]);
    };
  }

  // For models, pusher updates are bound on the client itself so that the
  // same event handler can be used for all models.  This allows us to not
  // worry about turning events on or off when a model begins/stops listening.
  Pusher.bind("update", emitEvent("reload"));
  Pusher.bind("commit", emitEvent("reload"));

  return {
    // Turns on listening to events on a given model key.
    listen: function(modelKey, preventMuteFilter) {
      var channel = Pusher.channel(modelKey),
          muteHandler;

      if (!channel) {
        Pusher.subscribe(modelKey);
      }

      muteHandler = $rootScope.$on("muting", function(event, keyToMute) {
        if (modelKey === keyToMute) {
          event.preventDefault();
        }
      });

      return function() {
        muteHandler();
        var event = $rootScope.$emit("muting", modelKey);
        if (!event.defaultPrevented) {
          console.log("mute successful", modelKey);
          Pusher.unsubscribe(modelKey);
        } else  {
          console.log("mute prrevented", modelKey);
        }
      };
    },

    // Turns off listening to events on a given model key.
    mute: function(modelKey) {
      console.log("Old mute called for ", modelKey);
    },
  };

});
